// Constant for toggle theme
export const LIGHT_THEME_NAME = 'light';
export const DARK_THEME_NAME = 'dark';
